import 'react-table/react-table.css'

import { DateFormat, Trans } from '@lingui/macro'
import { i18nMark } from '@lingui/react'
import { Button, Link, Paper } from '@material-ui/core'
import { css } from 'emotion'
import React from 'react'
import styled from 'react-emotion/macro'
import ReactTable, { Column, Filter } from 'react-table'
import {
  EAccountStatus,
  getAccountStatus,
  IAccount,
} from 'shopify-payment-core'

import { AccountInvoiceCell } from '../atoms/AccountInvoiceCell'
import { AccountStatus } from '../atoms/AccountStatus'
import { AccountStatusFilter } from '../atoms/AccountStatusFilter'
import { CopyToClipboard } from '../atoms/CopyToClipboard'

interface IProps {
  isLoading: boolean
  accounts: IAccount[]
  onAccountClick(accountId: ID): void
}

const alignRight = css`
  text-align: right;
`

const alignCenter = css`
  text-align: center;
`

const Container = styled(Paper)`
  margin: 0.5rem;
  padding: 0.5rem;
`

const sortByDate = (a: string, b: string) => {
  if (!a) {
    return 1
  }
  if (!b) {
    return -1
  }
  return new Date(a) > new Date(b) ? 1 : -1
}

const columns: Column[] = [
  {
    Header: i18nMark('Stav'),
    Cell({ original }) {
      return <AccountStatus account={original} />
    },
    id: 'status',
    maxWidth: 120,
    filterable: true,
    Filter: ({ filter, onChange }) => (
      <AccountStatusFilter
        onChange={onChange}
        status={filter ? filter.value : null}
      />
    ),
    filterMethod(filter: Filter, row: { status: EAccountStatus }) {
      return !filter || filter.value === row.status
    },
    accessor: (account: IAccount) => getAccountStatus(account),
  },
  {
    Header: i18nMark('Fakturace'),
    accessor: 'invoiceDueDate',
    sortMethod: sortByDate,
    filterable: false,
    maxWidth: 200,
    className: alignCenter,
    Cell: ({ original }) => <AccountInvoiceCell account={original} />,
  },
  {
    Header: i18nMark('Název obchodu'),
    accessor: 'shopName',
    Cell: ({ value }) => (
      <Link href={`https://${value}.myshopify.com`} target={value}>
        {value}
      </Link>
    ),
  },
  { Header: i18nMark('Kontaktní email'), accessor: 'contactEmail' },
  { Header: i18nMark('IČ'), accessor: 'billingIdentity', maxWidth: 120 },
  {
    id: 'amount',
    Header: i18nMark('Celkem $'),
    accessor: (account: IAccount) =>
      account.stats && Number(account.stats.totalAmount),
    filterable: false,
    className: alignRight,
    // sortMethod: (a, b) => a - b,
    Cell: ({ value }) => (value !== undefined ? value.toFixed(0) : '0'),
    maxWidth: 80,
  },
  { Header: i18nMark('Poznámka admina'), accessor: 'adminNote' },
  {
    Header: i18nMark('ID'),
    accessor: 'id',
    filterable: false,
    maxWidth: 80,
    className: alignCenter,
    Cell: ({ value }) => <CopyToClipboard text={value} />,
  },
  {
    Header: 'Registrace',
    Cell: ({ value }) => (
      <DateFormat
        value={value}
        format={{ day: 'numeric', month: 'narrow', year: 'numeric' }}
      />
    ),
    accessor: 'createdAt',
    filterable: false,
    sortMethod: sortByDate,
    maxWidth: 100,
    className: alignRight,
  },
]

export const AccountsTable: React.FC<IProps> = ({
  accounts,
  isLoading,
  onAccountClick,
}) => {
  const detailColumn: Column = {
    Cell({ value }) {
      return (
        <Button onClick={() => onAccountClick(value)} size="small">
          <Trans>Detail</Trans>
        </Button>
      )
    },
    accessor: 'id',
    maxWidth: 80,
    filterable: false,
  }
  return (
    <Container>
      <ReactTable
        loading={isLoading}
        columns={[detailColumn, ...columns]}
        data={accounts}
        filterable={true}
        defaultPageSize={20}
        defaultSorted={[
          { id: 'status', desc: false },
          { id: 'shopName', desc: false },
        ]}
        className="-highlight"
        style={{ height: '100%' }}
      />
    </Container>
  )
}
